<template>
  <div class="input-error" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false
    }
  }
}
</script>
